export const CurrencyFormatter = (value) =>{
    value = value.toString()
    return "R$ " + value.replace(",","").replace(".",",")
}